import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthServiceCustom } from 'src/shared/service/auth.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';


@Injectable()
export class UserAuthorizedCanActivate  {// CanActivateChild

    constructor(private authService: AuthServiceCustom) {
    }

    public static isAuthorized(authService, route) {
      return authService.AccessToken && authService.isThePageAuthorized(route.data.screenId);
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
        const url: string = state.url;

        if (this.authService.AccessToken && !this.authService.configReady) {
          return this.authService.clientConfigLoaded.pipe(map(x => {
            return this.checkAndRedirect(url, route);
          }));
        }

      return this.checkAndRedirect(url, route);
    }

    private checkAndRedirect(url: string, route: ActivatedRouteSnapshot): boolean {
      if (UserAuthorizedCanActivate.isAuthorized(this.authService, route)) {
        return true;
      }
      this.authService.setRedirectUrl(url);
      this.authService.navigateToLogin();
      return false;
    }
}
